import React, { useEffect } from 'react'
import Process from './process'
import Information from './information'
import './index.less'

function EntryConsultation() {
  const [selectedTab, setSelectedTab] = React.useState(1)

  const handleClickTab = (type: number) => {
    if (type !== selectedTab) {
      setSelectedTab(type)
    }
  }

  return (
    <div className="pc-entry-consultation-wrapper">
      <div className="tab-content">
        <div
          className={selectedTab === 1 ? 'selected-item' : 'item'}
          onClick={() => {
            handleClickTab(1)
          }}
        >
          入驻流程
        </div>
        <div
          className={selectedTab === 2 ? 'selected-item' : 'item'}
          onClick={() => {
            handleClickTab(2)
          }}
        >
          入驻材料及费用
        </div>
      </div>
      {selectedTab === 1 && <Process setSelectedTab={setSelectedTab} />}
      {selectedTab === 2 && <Information />}
    </div>
  )
}

export default EntryConsultation

